<template>
  <v-card
    @click="() => typeof widget.link!=='undefined' ? move(widget.link) : null"
    v-if="widget.template==='defaultIconLeftTableDesign'"
    :style="widget.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.color "
    dark
    tile
  >
    <v-card-actions style="z-index: 100 ; position: relative"  class="pa-3 ma-0">
      <v-img
        max-height="50"
        max-width="50"
        class="rounded"
        contain
        style="position: absolute ; z-index: 99 ; opacity: 0.2  ; left: 10px"
        :src="getImage(widget.icon)"
      ></v-img>
      {{ widget.title }}
      {{ isNaN(widget.model) ? widget.model : Intl.NumberFormat().format(parseInt(widget.model)) }} {{ widget.prefix }}
    </v-card-actions>
  </v-card>
</template>

<script>
import router from "@/router";
import {getImage} from '@/../src/views/generator/page-handler'

export default {
  name: "tile-icon-left-default-table-design",
  data() {
    return {
      getImage: getImage
    }
  },
  props: {
    widget: Object
  },
  methods: {
    move(link) {
      let result = link.includes("http");
      if (result) {
        window.location.href = link
      } else {
        router.push(link)
      }
    }
  }
}
</script>

<style scoped>

</style>
